import React from 'react';
import { createSvgIcon } from '../../utils/createSvgIcon';

export const TransactionTransferIn = createSvgIcon(
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24">
    <g fill="currentColor">
      <path
        d="M20.6665 13.4991V13.0919H19.6391V13.3827C19.6391 14.394 18.8115 15.2139 17.7903 15.2139H7.38868L9.18526 13.1765L8.54785 12.4512L5.6665 15.7236L8.54968 19L9.18874 18.2661L7.39399 16.2315H17.9078C19.4313 16.2315 20.6665 15.0082 20.6665 13.4991Z"
        fillOpacity="0.5"
      />
      <path d="M5.6665 9.50091V9.90805H6.6939V9.61726C6.6939 8.60602 7.52155 7.78611 8.54272 7.78611H18.9443L17.1477 9.82347L17.7851 10.5488L20.6665 7.2764L17.7833 4L17.1443 4.73388L18.939 6.76852H8.42525C6.90155 6.76852 5.6665 7.99177 5.6665 9.50091Z" />
    </g>
  </svg>,
  'TransactionTransferIn'
);
